// A reducer takes in two things :

// 1. the action (info about what happend)
// import { UPDATE_EVENT_STATUS } from '../actions/playerSrc';
import ActionTypes from '../actions/types';
// 2. copy of current state

const initialState = {
  status: eventDataProps.data.status,
  error: eventDataProps.error,
  error_msg: eventDataProps.error_msg,
  data: eventDataProps.data,
  object: eventDataProps.object,
  action: eventDataProps.action,
};

//  This needs to be deprecate from here, Moved to constants/general.ts
export const VIDEO_STATUS = {
  pending: 'PENDING',
  uploading: 'UPLOADING',
  uploadingFailed: 'UPLOAD_FAILED',
  uploaded: 'UPLOADED',
  allocating: 'ALLOCATING',
  allocated: 'ALLOCATED', // newdata 10 seconds
  allocateFailed: 'ALLOCATE_FAILED',
  streaming: 'STREAMING',
  streamingFailed: 'STREAMING_FAILED',
  closing: 'CLOSING',
  archiving: 'ARCHIVING',
  archivingFailed: 'ARCHIVING_FAILED',
  archived: 'ARCHIVED',
  archivedS3: 'ARCHIVED_S3',
  closed: 'CLOSED',
  expired: 'EXPIRED',
  retrieving: 'RETRIEVING',
  retrieved: 'RETRIEVED',
  notfound: 'ERROR', // This is an abitary value; do we have an error code for 'event not found'?
};
// in this camera function, you can add actions that update state data.
function event(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.UPDATE_EVENT_STATUS:
      return {
        ...state,
        status: action.payload,
        data: {
          ...state.data,
          status: action.payload,
        }
      };
    case ActionTypes.UPDATE_CURRENT_EVENT:
      return {
        ...state,
        data: action.payload.data,
      };
    default:
      return state;
  }
}

export default event;
